import { ListItem } from '@material-ui/core'

import React, { FC } from 'react'

const ListItemLink: FC<any> = (props: any) => {
  return <ListItem button component="a" {...props} />
}

export default ListItemLink
